<div class="list">
  <coa-list-element
    (click)="onItemSelected(element.offlineTraffics.id)"
    *ngFor="let element of elements"
    [chartLabel]="dateRange"
    [chartValue]="element.offlineTraffics.offlineTraffic | labelValue"
    [clientId]="clientId"
    [label]="element.locationUnitIds.length + ' ' + ('stores included' | translate)"
    [name]="element.offlineTraffics.seriesName"
    [number]="element.offlineTraffics.position"
    [percentageChangeLabel]="'Foot traffic' | translate"
    [percentageChangeValue]="element.changeInFootTraffic"
    [percentage]="element?.offlineTraffics?.paymentConversion !== null ? {label: 'Payment conversion' | translate, value: element?.offlineTraffics?.paymentConversion} : null"
    [totalLabel]="'Traffic share' | translate"
    [totalValue]="element.offlineTraffics.trafficShare"
    class="list-element"
    data-cy="dashboard-custom-groups.list-element">
  </coa-list-element>
</div>
